module.exports = __webpack_public_path__ + "img/1728349637886-Screenshot_8-10-2024_976_www.instagram.com.jpeg.5f3aa357.webp";